import invariant from 'invariant';
import _ from 'lodash';

import checkStore from './checkStore';
import createReducer from '../reducers';

export const injectReducerFactory = (store, isValid) => (key, reducer) => {
  if (!isValid) checkStore(store);

  invariant(
    _.isString(key) && !_.isEmpty(key) && _.isFunction(reducer),
    '(app/utils...) injectReducer: Expected `reducer` to be a reducer function',
  );

  if (
    Reflect.has(store.injectedReducers, key) &&
    store.injectedReducers[key] === reducer
  )
    return;

  store.injectedReducers[key] = reducer; // eslint-disable-line no-param-reassign
  store.replaceReducer(createReducer(store.injectedReducers));
};

const getInjectors = store => {
  checkStore(store);
  return {
    injectReducer: injectReducerFactory(store, true),
  };
};

export default getInjectors;
